
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("6AY0f"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("c1Vp4"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("I9jep"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("bTyz6"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("cEKV7"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("bIqeo"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("iu1t9"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("5Htjc"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("7x2hC"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("8opxz"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("bvqVt"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("b4Ghd"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("6AY0f", function(module, exports) {

let $4cd4a6357053f794$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4cd4a6357053f794$var$load("2YffH"),
    $4cd4a6357053f794$var$load("8Kivm"),
    $4cd4a6357053f794$var$load("dEFLb"),
    $4cd4a6357053f794$var$load("lqFMg"),
    $4cd4a6357053f794$var$load("1wMbb"),
    $4cd4a6357053f794$var$load("5HzoS"),
    $4cd4a6357053f794$var$load("iQ0Jm"),
    $4cd4a6357053f794$var$load("6lUA3"),
    $4cd4a6357053f794$var$load("8Tr2S"),
    $4cd4a6357053f794$var$load("eBRUf"),
    $4cd4a6357053f794$var$load("d63le"),
    $4cd4a6357053f794$var$load("l8GL7"),
    $4cd4a6357053f794$var$load("h4Nf7"),
    $4cd4a6357053f794$var$load("7f9Fz"),
    $4cd4a6357053f794$var$load("8YSo7"),
    $4cd4a6357053f794$var$load("aowzi"),
    $4cd4a6357053f794$var$load("7PE6o"),
    $4cd4a6357053f794$var$load("lXGg9"),
    $4cd4a6357053f794$var$load("hy3sK"),
    $4cd4a6357053f794$var$load("g9CVe"),
    $4cd4a6357053f794$var$load("aeEUI"),
    $4cd4a6357053f794$var$load("eY3St"),
    $4cd4a6357053f794$var$load("bkd4T"),
    $4cd4a6357053f794$var$load("6wr18"),
    $4cd4a6357053f794$var$load("kjZZD"),
    $4cd4a6357053f794$var$load("Wowvf"),
    $4cd4a6357053f794$var$load("kHOMt"),
    $4cd4a6357053f794$var$load("dRpV3"),
    $4cd4a6357053f794$var$load("ffEVr"),
    $4cd4a6357053f794$var$load("hhss7"),
    $4cd4a6357053f794$var$load("biF4A"),
    $4cd4a6357053f794$var$load("dDnlz"),
    $4cd4a6357053f794$var$load("6u1hm"),
    $4cd4a6357053f794$var$load("8joP2"),
    $4cd4a6357053f794$var$load("8k5x9"),
    $4cd4a6357053f794$var$load("jryxA"),
    $4cd4a6357053f794$var$load("dWZbK"),
    $4cd4a6357053f794$var$load("iqKwT"),
    $4cd4a6357053f794$var$load("kULV9"),
    $4cd4a6357053f794$var$load("jEmf3"),
    $4cd4a6357053f794$var$load("kUbUu"),
    $4cd4a6357053f794$var$load("2PePB"),
    $4cd4a6357053f794$var$load("lnKog"),
    $4cd4a6357053f794$var$load("9ftJe"),
    $4cd4a6357053f794$var$load("h3ABO"),
    $4cd4a6357053f794$var$load("kC80R"),
    $4cd4a6357053f794$var$load("7EorR"),
    $4cd4a6357053f794$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("c1Vp4", function(module, exports) {

let $8c221b23be944494$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c221b23be944494$var$load("2YffH"),
    $8c221b23be944494$var$load("8Kivm"),
    $8c221b23be944494$var$load("dEFLb"),
    $8c221b23be944494$var$load("lqFMg"),
    $8c221b23be944494$var$load("1wMbb"),
    $8c221b23be944494$var$load("5HzoS"),
    $8c221b23be944494$var$load("iQ0Jm"),
    $8c221b23be944494$var$load("6lUA3"),
    $8c221b23be944494$var$load("8Tr2S"),
    $8c221b23be944494$var$load("eBRUf"),
    $8c221b23be944494$var$load("d63le"),
    $8c221b23be944494$var$load("l8GL7"),
    $8c221b23be944494$var$load("h4Nf7"),
    $8c221b23be944494$var$load("7f9Fz"),
    $8c221b23be944494$var$load("8YSo7"),
    $8c221b23be944494$var$load("aowzi"),
    $8c221b23be944494$var$load("7PE6o"),
    $8c221b23be944494$var$load("lXGg9"),
    $8c221b23be944494$var$load("hy3sK"),
    $8c221b23be944494$var$load("g9CVe"),
    $8c221b23be944494$var$load("aeEUI"),
    $8c221b23be944494$var$load("eY3St"),
    $8c221b23be944494$var$load("bkd4T"),
    $8c221b23be944494$var$load("6wr18"),
    $8c221b23be944494$var$load("kjZZD"),
    $8c221b23be944494$var$load("Wowvf"),
    $8c221b23be944494$var$load("kHOMt"),
    $8c221b23be944494$var$load("dRpV3"),
    $8c221b23be944494$var$load("ffEVr"),
    $8c221b23be944494$var$load("hhss7"),
    $8c221b23be944494$var$load("biF4A"),
    $8c221b23be944494$var$load("dDnlz"),
    $8c221b23be944494$var$load("6u1hm"),
    $8c221b23be944494$var$load("8joP2"),
    $8c221b23be944494$var$load("8k5x9"),
    $8c221b23be944494$var$load("jryxA"),
    $8c221b23be944494$var$load("dWZbK"),
    $8c221b23be944494$var$load("iqKwT"),
    $8c221b23be944494$var$load("kULV9"),
    $8c221b23be944494$var$load("jEmf3"),
    $8c221b23be944494$var$load("kUbUu"),
    $8c221b23be944494$var$load("2PePB"),
    $8c221b23be944494$var$load("lnKog"),
    $8c221b23be944494$var$load("9ftJe"),
    $8c221b23be944494$var$load("h3ABO"),
    $8c221b23be944494$var$load("kC80R"),
    $8c221b23be944494$var$load("7EorR"),
    $8c221b23be944494$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("I9jep", function(module, exports) {

let $084b54c920b1291d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $084b54c920b1291d$var$load("2YffH"),
    $084b54c920b1291d$var$load("8Kivm"),
    $084b54c920b1291d$var$load("dEFLb"),
    $084b54c920b1291d$var$load("lqFMg"),
    $084b54c920b1291d$var$load("1wMbb"),
    $084b54c920b1291d$var$load("5HzoS"),
    $084b54c920b1291d$var$load("iQ0Jm"),
    $084b54c920b1291d$var$load("6lUA3"),
    $084b54c920b1291d$var$load("8Tr2S"),
    $084b54c920b1291d$var$load("eBRUf"),
    $084b54c920b1291d$var$load("d63le"),
    $084b54c920b1291d$var$load("l8GL7"),
    $084b54c920b1291d$var$load("h4Nf7"),
    $084b54c920b1291d$var$load("7f9Fz"),
    $084b54c920b1291d$var$load("8YSo7"),
    $084b54c920b1291d$var$load("aowzi"),
    $084b54c920b1291d$var$load("7PE6o"),
    $084b54c920b1291d$var$load("lXGg9"),
    $084b54c920b1291d$var$load("hy3sK"),
    $084b54c920b1291d$var$load("g9CVe"),
    $084b54c920b1291d$var$load("aeEUI"),
    $084b54c920b1291d$var$load("eY3St"),
    $084b54c920b1291d$var$load("bkd4T"),
    $084b54c920b1291d$var$load("6wr18"),
    $084b54c920b1291d$var$load("kjZZD"),
    $084b54c920b1291d$var$load("Wowvf"),
    $084b54c920b1291d$var$load("kHOMt"),
    $084b54c920b1291d$var$load("dRpV3"),
    $084b54c920b1291d$var$load("ffEVr"),
    $084b54c920b1291d$var$load("hhss7"),
    $084b54c920b1291d$var$load("biF4A"),
    $084b54c920b1291d$var$load("dDnlz"),
    $084b54c920b1291d$var$load("6u1hm"),
    $084b54c920b1291d$var$load("8joP2"),
    $084b54c920b1291d$var$load("8k5x9"),
    $084b54c920b1291d$var$load("jryxA"),
    $084b54c920b1291d$var$load("dWZbK"),
    $084b54c920b1291d$var$load("iqKwT"),
    $084b54c920b1291d$var$load("kULV9"),
    $084b54c920b1291d$var$load("jEmf3"),
    $084b54c920b1291d$var$load("kUbUu"),
    $084b54c920b1291d$var$load("2PePB"),
    $084b54c920b1291d$var$load("lnKog"),
    $084b54c920b1291d$var$load("9ftJe"),
    $084b54c920b1291d$var$load("h3ABO"),
    $084b54c920b1291d$var$load("kC80R"),
    $084b54c920b1291d$var$load("7EorR"),
    $084b54c920b1291d$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("bTyz6", function(module, exports) {

let $8a8fa4af43feb33f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8a8fa4af43feb33f$var$load("lXGg9"),
    $8a8fa4af43feb33f$var$load("hy3sK"),
    $8a8fa4af43feb33f$var$load("2YffH"),
    $8a8fa4af43feb33f$var$load("dEFLb"),
    $8a8fa4af43feb33f$var$load("lqFMg"),
    $8a8fa4af43feb33f$var$load("2PePB"),
    $8a8fa4af43feb33f$var$load("1wMbb"),
    $8a8fa4af43feb33f$var$load("5HzoS"),
    $8a8fa4af43feb33f$var$load("6lUA3"),
    $8a8fa4af43feb33f$var$load("eBRUf"),
    $8a8fa4af43feb33f$var$load("d63le"),
    $8a8fa4af43feb33f$var$load("l8GL7"),
    $8a8fa4af43feb33f$var$load("h4Nf7"),
    $8a8fa4af43feb33f$var$load("7f9Fz"),
    $8a8fa4af43feb33f$var$load("8YSo7"),
    $8a8fa4af43feb33f$var$load("aowzi"),
    $8a8fa4af43feb33f$var$load("7PE6o"),
    $8a8fa4af43feb33f$var$load("g9CVe"),
    $8a8fa4af43feb33f$var$load("aeEUI"),
    $8a8fa4af43feb33f$var$load("eY3St"),
    $8a8fa4af43feb33f$var$load("bkd4T"),
    $8a8fa4af43feb33f$var$load("6wr18"),
    $8a8fa4af43feb33f$var$load("kjZZD"),
    $8a8fa4af43feb33f$var$load("Wowvf"),
    $8a8fa4af43feb33f$var$load("kHOMt"),
    $8a8fa4af43feb33f$var$load("dRpV3"),
    $8a8fa4af43feb33f$var$load("ffEVr"),
    $8a8fa4af43feb33f$var$load("hhss7"),
    $8a8fa4af43feb33f$var$load("biF4A"),
    $8a8fa4af43feb33f$var$load("dDnlz"),
    $8a8fa4af43feb33f$var$load("6u1hm"),
    $8a8fa4af43feb33f$var$load("8joP2"),
    $8a8fa4af43feb33f$var$load("8k5x9"),
    $8a8fa4af43feb33f$var$load("jryxA"),
    $8a8fa4af43feb33f$var$load("dWZbK"),
    $8a8fa4af43feb33f$var$load("iqKwT"),
    $8a8fa4af43feb33f$var$load("kULV9"),
    $8a8fa4af43feb33f$var$load("jEmf3"),
    $8a8fa4af43feb33f$var$load("kUbUu"),
    $8a8fa4af43feb33f$var$load("9ftJe"),
    $8a8fa4af43feb33f$var$load("h3ABO"),
    $8a8fa4af43feb33f$var$load("kC80R"),
    $8a8fa4af43feb33f$var$load("7EorR"),
    $8a8fa4af43feb33f$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("cEKV7", function(module, exports) {

let $936d9dd66de6825d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $936d9dd66de6825d$var$load("lXGg9"),
    $936d9dd66de6825d$var$load("hy3sK"),
    $936d9dd66de6825d$var$load("2YffH"),
    $936d9dd66de6825d$var$load("dEFLb"),
    $936d9dd66de6825d$var$load("lqFMg"),
    $936d9dd66de6825d$var$load("2PePB"),
    $936d9dd66de6825d$var$load("1wMbb"),
    $936d9dd66de6825d$var$load("5HzoS"),
    $936d9dd66de6825d$var$load("6lUA3"),
    $936d9dd66de6825d$var$load("eBRUf"),
    $936d9dd66de6825d$var$load("d63le"),
    $936d9dd66de6825d$var$load("l8GL7"),
    $936d9dd66de6825d$var$load("h4Nf7"),
    $936d9dd66de6825d$var$load("7f9Fz"),
    $936d9dd66de6825d$var$load("8YSo7"),
    $936d9dd66de6825d$var$load("aowzi"),
    $936d9dd66de6825d$var$load("7PE6o"),
    $936d9dd66de6825d$var$load("g9CVe"),
    $936d9dd66de6825d$var$load("aeEUI"),
    $936d9dd66de6825d$var$load("eY3St"),
    $936d9dd66de6825d$var$load("bkd4T"),
    $936d9dd66de6825d$var$load("6wr18"),
    $936d9dd66de6825d$var$load("kjZZD"),
    $936d9dd66de6825d$var$load("Wowvf"),
    $936d9dd66de6825d$var$load("kHOMt"),
    $936d9dd66de6825d$var$load("dRpV3"),
    $936d9dd66de6825d$var$load("ffEVr"),
    $936d9dd66de6825d$var$load("hhss7"),
    $936d9dd66de6825d$var$load("biF4A"),
    $936d9dd66de6825d$var$load("dDnlz"),
    $936d9dd66de6825d$var$load("6u1hm"),
    $936d9dd66de6825d$var$load("8joP2"),
    $936d9dd66de6825d$var$load("8k5x9"),
    $936d9dd66de6825d$var$load("jryxA"),
    $936d9dd66de6825d$var$load("dWZbK"),
    $936d9dd66de6825d$var$load("iqKwT"),
    $936d9dd66de6825d$var$load("kULV9"),
    $936d9dd66de6825d$var$load("jEmf3"),
    $936d9dd66de6825d$var$load("kUbUu"),
    $936d9dd66de6825d$var$load("9ftJe"),
    $936d9dd66de6825d$var$load("h3ABO"),
    $936d9dd66de6825d$var$load("kC80R"),
    $936d9dd66de6825d$var$load("7EorR"),
    $936d9dd66de6825d$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("bIqeo", function(module, exports) {

let $887826c116b252df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $887826c116b252df$var$load("lXGg9"),
    $887826c116b252df$var$load("hy3sK"),
    $887826c116b252df$var$load("2YffH"),
    $887826c116b252df$var$load("dEFLb"),
    $887826c116b252df$var$load("lqFMg"),
    $887826c116b252df$var$load("2PePB"),
    $887826c116b252df$var$load("1wMbb"),
    $887826c116b252df$var$load("5HzoS"),
    $887826c116b252df$var$load("6lUA3"),
    $887826c116b252df$var$load("eBRUf"),
    $887826c116b252df$var$load("d63le"),
    $887826c116b252df$var$load("l8GL7"),
    $887826c116b252df$var$load("h4Nf7"),
    $887826c116b252df$var$load("7f9Fz"),
    $887826c116b252df$var$load("8YSo7"),
    $887826c116b252df$var$load("aowzi"),
    $887826c116b252df$var$load("7PE6o"),
    $887826c116b252df$var$load("g9CVe"),
    $887826c116b252df$var$load("aeEUI"),
    $887826c116b252df$var$load("eY3St"),
    $887826c116b252df$var$load("bkd4T"),
    $887826c116b252df$var$load("6wr18"),
    $887826c116b252df$var$load("kjZZD"),
    $887826c116b252df$var$load("Wowvf"),
    $887826c116b252df$var$load("kHOMt"),
    $887826c116b252df$var$load("dRpV3"),
    $887826c116b252df$var$load("ffEVr"),
    $887826c116b252df$var$load("hhss7"),
    $887826c116b252df$var$load("biF4A"),
    $887826c116b252df$var$load("dDnlz"),
    $887826c116b252df$var$load("6u1hm"),
    $887826c116b252df$var$load("8joP2"),
    $887826c116b252df$var$load("8k5x9"),
    $887826c116b252df$var$load("jryxA"),
    $887826c116b252df$var$load("dWZbK"),
    $887826c116b252df$var$load("iqKwT"),
    $887826c116b252df$var$load("kULV9"),
    $887826c116b252df$var$load("jEmf3"),
    $887826c116b252df$var$load("kUbUu"),
    $887826c116b252df$var$load("9ftJe"),
    $887826c116b252df$var$load("h3ABO"),
    $887826c116b252df$var$load("kC80R"),
    $887826c116b252df$var$load("7EorR"),
    $887826c116b252df$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("iu1t9", function(module, exports) {

let $d74c2b129063ae4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d74c2b129063ae4f$var$load("lXGg9"),
    $d74c2b129063ae4f$var$load("hy3sK"),
    $d74c2b129063ae4f$var$load("2YffH"),
    $d74c2b129063ae4f$var$load("dEFLb"),
    $d74c2b129063ae4f$var$load("lqFMg"),
    $d74c2b129063ae4f$var$load("1wMbb"),
    $d74c2b129063ae4f$var$load("5HzoS"),
    $d74c2b129063ae4f$var$load("6lUA3"),
    $d74c2b129063ae4f$var$load("eBRUf"),
    $d74c2b129063ae4f$var$load("d63le"),
    $d74c2b129063ae4f$var$load("l8GL7"),
    $d74c2b129063ae4f$var$load("h4Nf7"),
    $d74c2b129063ae4f$var$load("7f9Fz"),
    $d74c2b129063ae4f$var$load("8YSo7"),
    $d74c2b129063ae4f$var$load("aowzi"),
    $d74c2b129063ae4f$var$load("7PE6o"),
    $d74c2b129063ae4f$var$load("g9CVe"),
    $d74c2b129063ae4f$var$load("aeEUI"),
    $d74c2b129063ae4f$var$load("eY3St"),
    $d74c2b129063ae4f$var$load("bkd4T"),
    $d74c2b129063ae4f$var$load("6wr18"),
    $d74c2b129063ae4f$var$load("kjZZD"),
    $d74c2b129063ae4f$var$load("Wowvf"),
    $d74c2b129063ae4f$var$load("kHOMt"),
    $d74c2b129063ae4f$var$load("dRpV3"),
    $d74c2b129063ae4f$var$load("ffEVr"),
    $d74c2b129063ae4f$var$load("hhss7"),
    $d74c2b129063ae4f$var$load("biF4A"),
    $d74c2b129063ae4f$var$load("dDnlz"),
    $d74c2b129063ae4f$var$load("6u1hm"),
    $d74c2b129063ae4f$var$load("8joP2"),
    $d74c2b129063ae4f$var$load("8k5x9"),
    $d74c2b129063ae4f$var$load("jryxA"),
    $d74c2b129063ae4f$var$load("dWZbK"),
    $d74c2b129063ae4f$var$load("iqKwT"),
    $d74c2b129063ae4f$var$load("kULV9"),
    $d74c2b129063ae4f$var$load("jEmf3"),
    $d74c2b129063ae4f$var$load("kUbUu"),
    $d74c2b129063ae4f$var$load("2PePB"),
    $d74c2b129063ae4f$var$load("lnKog"),
    $d74c2b129063ae4f$var$load("9ftJe"),
    $d74c2b129063ae4f$var$load("h3ABO"),
    $d74c2b129063ae4f$var$load("kC80R"),
    $d74c2b129063ae4f$var$load("7EorR"),
    $d74c2b129063ae4f$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("5Htjc", function(module, exports) {

let $4267b40272724bce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4267b40272724bce$var$load("2YffH"),
    $4267b40272724bce$var$load("dEFLb"),
    $4267b40272724bce$var$load("lqFMg"),
    $4267b40272724bce$var$load("1wMbb"),
    $4267b40272724bce$var$load("5HzoS"),
    $4267b40272724bce$var$load("6lUA3"),
    $4267b40272724bce$var$load("8Tr2S"),
    $4267b40272724bce$var$load("eBRUf"),
    $4267b40272724bce$var$load("d63le"),
    $4267b40272724bce$var$load("l8GL7"),
    $4267b40272724bce$var$load("h4Nf7"),
    $4267b40272724bce$var$load("7f9Fz"),
    $4267b40272724bce$var$load("8YSo7"),
    $4267b40272724bce$var$load("aowzi"),
    $4267b40272724bce$var$load("7PE6o"),
    $4267b40272724bce$var$load("lXGg9"),
    $4267b40272724bce$var$load("hy3sK"),
    $4267b40272724bce$var$load("g9CVe"),
    $4267b40272724bce$var$load("aeEUI"),
    $4267b40272724bce$var$load("eY3St"),
    $4267b40272724bce$var$load("bkd4T"),
    $4267b40272724bce$var$load("6wr18"),
    $4267b40272724bce$var$load("kjZZD"),
    $4267b40272724bce$var$load("Wowvf"),
    $4267b40272724bce$var$load("kHOMt"),
    $4267b40272724bce$var$load("dRpV3"),
    $4267b40272724bce$var$load("ffEVr"),
    $4267b40272724bce$var$load("dTsOE"),
    $4267b40272724bce$var$load("hhss7"),
    $4267b40272724bce$var$load("biF4A"),
    $4267b40272724bce$var$load("dDnlz"),
    $4267b40272724bce$var$load("6u1hm"),
    $4267b40272724bce$var$load("8joP2"),
    $4267b40272724bce$var$load("8k5x9"),
    $4267b40272724bce$var$load("jryxA"),
    $4267b40272724bce$var$load("dWZbK"),
    $4267b40272724bce$var$load("iqKwT"),
    $4267b40272724bce$var$load("kULV9"),
    $4267b40272724bce$var$load("jEmf3"),
    $4267b40272724bce$var$load("kUbUu"),
    $4267b40272724bce$var$load("2PePB"),
    $4267b40272724bce$var$load("lnKog"),
    $4267b40272724bce$var$load("9ftJe"),
    $4267b40272724bce$var$load("h3ABO"),
    $4267b40272724bce$var$load("kC80R"),
    $4267b40272724bce$var$load("7EorR"),
    $4267b40272724bce$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("7x2hC", function(module, exports) {

let $57bd62e2b99bb1bc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57bd62e2b99bb1bc$var$load("2YffH"),
    $57bd62e2b99bb1bc$var$load("dEFLb"),
    $57bd62e2b99bb1bc$var$load("lqFMg"),
    $57bd62e2b99bb1bc$var$load("1wMbb"),
    $57bd62e2b99bb1bc$var$load("5HzoS"),
    $57bd62e2b99bb1bc$var$load("6lUA3"),
    $57bd62e2b99bb1bc$var$load("8Tr2S"),
    $57bd62e2b99bb1bc$var$load("eBRUf"),
    $57bd62e2b99bb1bc$var$load("d63le"),
    $57bd62e2b99bb1bc$var$load("l8GL7"),
    $57bd62e2b99bb1bc$var$load("h4Nf7"),
    $57bd62e2b99bb1bc$var$load("7f9Fz"),
    $57bd62e2b99bb1bc$var$load("8YSo7"),
    $57bd62e2b99bb1bc$var$load("aowzi"),
    $57bd62e2b99bb1bc$var$load("7PE6o"),
    $57bd62e2b99bb1bc$var$load("lXGg9"),
    $57bd62e2b99bb1bc$var$load("hy3sK"),
    $57bd62e2b99bb1bc$var$load("g9CVe"),
    $57bd62e2b99bb1bc$var$load("aeEUI"),
    $57bd62e2b99bb1bc$var$load("eY3St"),
    $57bd62e2b99bb1bc$var$load("bkd4T"),
    $57bd62e2b99bb1bc$var$load("6wr18"),
    $57bd62e2b99bb1bc$var$load("kjZZD"),
    $57bd62e2b99bb1bc$var$load("Wowvf"),
    $57bd62e2b99bb1bc$var$load("kHOMt"),
    $57bd62e2b99bb1bc$var$load("dRpV3"),
    $57bd62e2b99bb1bc$var$load("ffEVr"),
    $57bd62e2b99bb1bc$var$load("dTsOE"),
    $57bd62e2b99bb1bc$var$load("hhss7"),
    $57bd62e2b99bb1bc$var$load("biF4A"),
    $57bd62e2b99bb1bc$var$load("dDnlz"),
    $57bd62e2b99bb1bc$var$load("6u1hm"),
    $57bd62e2b99bb1bc$var$load("8joP2"),
    $57bd62e2b99bb1bc$var$load("8k5x9"),
    $57bd62e2b99bb1bc$var$load("jryxA"),
    $57bd62e2b99bb1bc$var$load("dWZbK"),
    $57bd62e2b99bb1bc$var$load("iqKwT"),
    $57bd62e2b99bb1bc$var$load("kULV9"),
    $57bd62e2b99bb1bc$var$load("jEmf3"),
    $57bd62e2b99bb1bc$var$load("kUbUu"),
    $57bd62e2b99bb1bc$var$load("2PePB"),
    $57bd62e2b99bb1bc$var$load("lnKog"),
    $57bd62e2b99bb1bc$var$load("9ftJe"),
    $57bd62e2b99bb1bc$var$load("h3ABO"),
    $57bd62e2b99bb1bc$var$load("kC80R"),
    $57bd62e2b99bb1bc$var$load("7EorR"),
    $57bd62e2b99bb1bc$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("8opxz", function(module, exports) {

let $61c4606e8f6fb686$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $61c4606e8f6fb686$var$load("lXGg9"),
    $61c4606e8f6fb686$var$load("hy3sK"),
    $61c4606e8f6fb686$var$load("2YffH"),
    $61c4606e8f6fb686$var$load("dEFLb"),
    $61c4606e8f6fb686$var$load("lqFMg"),
    $61c4606e8f6fb686$var$load("2PePB"),
    $61c4606e8f6fb686$var$load("1wMbb"),
    $61c4606e8f6fb686$var$load("5HzoS"),
    $61c4606e8f6fb686$var$load("6lUA3"),
    $61c4606e8f6fb686$var$load("eBRUf"),
    $61c4606e8f6fb686$var$load("d63le"),
    $61c4606e8f6fb686$var$load("l8GL7"),
    $61c4606e8f6fb686$var$load("h4Nf7"),
    $61c4606e8f6fb686$var$load("7f9Fz"),
    $61c4606e8f6fb686$var$load("8YSo7"),
    $61c4606e8f6fb686$var$load("aowzi"),
    $61c4606e8f6fb686$var$load("7PE6o"),
    $61c4606e8f6fb686$var$load("g9CVe"),
    $61c4606e8f6fb686$var$load("aeEUI"),
    $61c4606e8f6fb686$var$load("eY3St"),
    $61c4606e8f6fb686$var$load("bkd4T"),
    $61c4606e8f6fb686$var$load("6wr18"),
    $61c4606e8f6fb686$var$load("kjZZD"),
    $61c4606e8f6fb686$var$load("Wowvf"),
    $61c4606e8f6fb686$var$load("kHOMt"),
    $61c4606e8f6fb686$var$load("dRpV3"),
    $61c4606e8f6fb686$var$load("ffEVr"),
    $61c4606e8f6fb686$var$load("hhss7"),
    $61c4606e8f6fb686$var$load("biF4A"),
    $61c4606e8f6fb686$var$load("dDnlz"),
    $61c4606e8f6fb686$var$load("6u1hm"),
    $61c4606e8f6fb686$var$load("8joP2"),
    $61c4606e8f6fb686$var$load("8k5x9"),
    $61c4606e8f6fb686$var$load("jryxA"),
    $61c4606e8f6fb686$var$load("dWZbK"),
    $61c4606e8f6fb686$var$load("iqKwT"),
    $61c4606e8f6fb686$var$load("kULV9"),
    $61c4606e8f6fb686$var$load("jEmf3"),
    $61c4606e8f6fb686$var$load("kUbUu"),
    $61c4606e8f6fb686$var$load("9ftJe"),
    $61c4606e8f6fb686$var$load("h3ABO"),
    $61c4606e8f6fb686$var$load("kC80R"),
    $61c4606e8f6fb686$var$load("7EorR"),
    $61c4606e8f6fb686$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("bvqVt", function(module, exports) {

let $860779e3a29cec8c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $860779e3a29cec8c$var$load("lXGg9"),
    $860779e3a29cec8c$var$load("hy3sK"),
    $860779e3a29cec8c$var$load("2YffH"),
    $860779e3a29cec8c$var$load("dEFLb"),
    $860779e3a29cec8c$var$load("lqFMg"),
    $860779e3a29cec8c$var$load("1wMbb"),
    $860779e3a29cec8c$var$load("5HzoS"),
    $860779e3a29cec8c$var$load("6lUA3"),
    $860779e3a29cec8c$var$load("eBRUf"),
    $860779e3a29cec8c$var$load("d63le"),
    $860779e3a29cec8c$var$load("l8GL7"),
    $860779e3a29cec8c$var$load("h4Nf7"),
    $860779e3a29cec8c$var$load("7f9Fz"),
    $860779e3a29cec8c$var$load("8YSo7"),
    $860779e3a29cec8c$var$load("aowzi"),
    $860779e3a29cec8c$var$load("7PE6o"),
    $860779e3a29cec8c$var$load("g9CVe"),
    $860779e3a29cec8c$var$load("aeEUI"),
    $860779e3a29cec8c$var$load("eY3St"),
    $860779e3a29cec8c$var$load("bkd4T"),
    $860779e3a29cec8c$var$load("6wr18"),
    $860779e3a29cec8c$var$load("kjZZD"),
    $860779e3a29cec8c$var$load("Wowvf"),
    $860779e3a29cec8c$var$load("kHOMt"),
    $860779e3a29cec8c$var$load("dRpV3"),
    $860779e3a29cec8c$var$load("ffEVr"),
    $860779e3a29cec8c$var$load("hhss7"),
    $860779e3a29cec8c$var$load("biF4A"),
    $860779e3a29cec8c$var$load("dDnlz"),
    $860779e3a29cec8c$var$load("6u1hm"),
    $860779e3a29cec8c$var$load("8joP2"),
    $860779e3a29cec8c$var$load("8k5x9"),
    $860779e3a29cec8c$var$load("jryxA"),
    $860779e3a29cec8c$var$load("dWZbK"),
    $860779e3a29cec8c$var$load("iqKwT"),
    $860779e3a29cec8c$var$load("kULV9"),
    $860779e3a29cec8c$var$load("jEmf3"),
    $860779e3a29cec8c$var$load("kUbUu"),
    $860779e3a29cec8c$var$load("2PePB"),
    $860779e3a29cec8c$var$load("lnKog"),
    $860779e3a29cec8c$var$load("9ftJe"),
    $860779e3a29cec8c$var$load("h3ABO"),
    $860779e3a29cec8c$var$load("kC80R"),
    $860779e3a29cec8c$var$load("7EorR"),
    $860779e3a29cec8c$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("b4Ghd", function(module, exports) {

let $8100dcb0d72bada4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8100dcb0d72bada4$var$load("lXGg9"),
    $8100dcb0d72bada4$var$load("hy3sK"),
    $8100dcb0d72bada4$var$load("2YffH"),
    $8100dcb0d72bada4$var$load("dEFLb"),
    $8100dcb0d72bada4$var$load("lqFMg"),
    $8100dcb0d72bada4$var$load("1wMbb"),
    $8100dcb0d72bada4$var$load("5HzoS"),
    $8100dcb0d72bada4$var$load("6lUA3"),
    $8100dcb0d72bada4$var$load("eBRUf"),
    $8100dcb0d72bada4$var$load("d63le"),
    $8100dcb0d72bada4$var$load("l8GL7"),
    $8100dcb0d72bada4$var$load("h4Nf7"),
    $8100dcb0d72bada4$var$load("7f9Fz"),
    $8100dcb0d72bada4$var$load("8YSo7"),
    $8100dcb0d72bada4$var$load("aowzi"),
    $8100dcb0d72bada4$var$load("7PE6o"),
    $8100dcb0d72bada4$var$load("g9CVe"),
    $8100dcb0d72bada4$var$load("aeEUI"),
    $8100dcb0d72bada4$var$load("eY3St"),
    $8100dcb0d72bada4$var$load("bkd4T"),
    $8100dcb0d72bada4$var$load("6wr18"),
    $8100dcb0d72bada4$var$load("kjZZD"),
    $8100dcb0d72bada4$var$load("Wowvf"),
    $8100dcb0d72bada4$var$load("kHOMt"),
    $8100dcb0d72bada4$var$load("dRpV3"),
    $8100dcb0d72bada4$var$load("ffEVr"),
    $8100dcb0d72bada4$var$load("hhss7"),
    $8100dcb0d72bada4$var$load("biF4A"),
    $8100dcb0d72bada4$var$load("dDnlz"),
    $8100dcb0d72bada4$var$load("6u1hm"),
    $8100dcb0d72bada4$var$load("8joP2"),
    $8100dcb0d72bada4$var$load("8k5x9"),
    $8100dcb0d72bada4$var$load("jryxA"),
    $8100dcb0d72bada4$var$load("dWZbK"),
    $8100dcb0d72bada4$var$load("iqKwT"),
    $8100dcb0d72bada4$var$load("kULV9"),
    $8100dcb0d72bada4$var$load("jEmf3"),
    $8100dcb0d72bada4$var$load("kUbUu"),
    $8100dcb0d72bada4$var$load("2PePB"),
    $8100dcb0d72bada4$var$load("lnKog"),
    $8100dcb0d72bada4$var$load("9ftJe"),
    $8100dcb0d72bada4$var$load("h3ABO"),
    $8100dcb0d72bada4$var$load("kC80R"),
    $8100dcb0d72bada4$var$load("7EorR"),
    $8100dcb0d72bada4$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey && (0, $9wGTI.fg)('confluence-fe-migrated-custom-content-display-fix')) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.810dcc96.js.map
